import { z } from 'zod';

export const NEW_VIEW_MAX_NAME_LENGTH = 64;

export const newViewDTOSchema = z.object({
  viewId: z.number().int(),
  organizationId: z.string().min(1),
  roadmapId: z.number().int(),
  name: z.string().max(NEW_VIEW_MAX_NAME_LENGTH).optional(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type NewViewDTO = z.infer<typeof newViewDTOSchema>;

export function isNewViewAutoGeneratedName(name: string = ''): boolean {
  const autoGeneratedPattern = /^(View)\s+\(\d+\)$/;
  return autoGeneratedPattern.test(name);
}

// Use generated name, e.g., "Swimlane (3)" if the view has no name set
export function getNewViewDisplayName(view: NewViewDTO): string {
  return view.name?.trim() || `View (${view.viewId})`;
}

export function validateNewView(data: { name?: string | null }, ctx: z.RefinementCtx) {
  if (data.name && isNewViewAutoGeneratedName(data.name)) {
    ctx.addIssue({
      code: 'custom',
      message: 'View name cannot use auto-generated format. Please choose a different name.',
      path: ['name'],
    });
  }
}

export const newViewInsertDTOSchema = z
  .object({
    roadmapId: z.number().int(),
    name: z.string().max(NEW_VIEW_MAX_NAME_LENGTH).optional().nullable(),
  })
  .strict()
  .superRefine(validateNewView);

export const newViewUpdateDTOSchema = z
  .object({
    name: z.string().max(NEW_VIEW_MAX_NAME_LENGTH).optional().nullable(),
  })
  .strict()
  .superRefine(validateNewView);

export type NewViewInsertDTO = z.infer<typeof newViewInsertDTOSchema>;
export type NewViewUpdateDTO = z.infer<typeof newViewUpdateDTOSchema>;
export type NewViewUpsertDTO = NewViewInsertDTO | NewViewUpdateDTO;
